import React from 'react';
import { Link } from 'react-router-dom';

import './Breadcrumb.scss';
import Icon from '../Icon';

const Breadcrumb = ({ to, label }) => (
  <Link
    className="breadcrumb"
    to={to}
  >
    <Icon
      weight="light"
      glyph="arrow-left"
    />
    {label}
  </Link>
);

export default Breadcrumb;
